export default "__VITE_ASSET__opsJoym2__"